const key = "proxy-datapoint";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/[0-9]*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Schema: {
			...resp.data.Data.Schema,
			properties: {
				...resp.data.Data.Schema.properties,
				species: {
					format: "datapoint",
					title: "Species Test",
					type: "datapoint",
					modelProperty: "Id",
					fieldCode: "TRIP.DETAILS.SPECIES.SINGLE"
				}
			}
		}
	};

	return resp;
};

export const addProxyDatapoint = [key, applicable, modify];